/**
 * @module event-handlers
 */

import { setLanguage } from '../../utils/language-utils';

/**
 * Attaches event listeners to specific elements on the page for various operations.
 */
function attachEventListeners() {
	// Handle setting of the language class on body load
	document.addEventListener( 'DOMContentLoaded', setLanguage );

	// Validate billing email on focus out
	const billingEmail = document.querySelector( '#billing_email' );
	if ( billingEmail ) {
		billingEmail.addEventListener( 'focusout', function() {
			if ( maximumEmails( this ) ) {
				document
					.querySelector( '#billing_email_field' )
					.classList.add( 'woocommerce-invalid', 'aftersnabela' );
			} else {
				document
					.querySelector( '#billing_email_field' )
					.classList.remove( 'woocommerce-invalid', 'aftersnabela' );
			}
		} );
	}

	// Validate billing email confirmation on focus out
	const billingEmailValidation = document.querySelector(
		'#billing_email_validation'
	);
	if ( billingEmailValidation ) {
		billingEmailValidation.addEventListener( 'focusout', function() {
			if ( validateEmail() ) {
				document
					.querySelector( '#billing_email_validation_field' )
					.classList.remove( 'woocommerce-invalid', 'aftersammamail' );
			} else {
				setTimeout( function() {
					document
						.querySelector( '#billing_email_validation_field' )
						.classList.add( 'woocommerce-invalid', 'aftersammamail' );
				}, 100 );
			}
		} );
	}
}

/**
 * Checks if an email string has more than one '@' symbol.
 *
 * @param {HTMLElement} emailElem - The email input element.
 * @return {boolean} - True if more than one '@', otherwise false.
 */
function maximumEmails( emailElem ) {
	return ( emailElem.value.match( /@/g ) || [] ).length > 1;
}

/**
 * Validates if the email and its confirmation match.
 *
 * @return {boolean} - True if they match, otherwise false.
 */
function validateEmail() {
	const email = document.querySelector( '#billing_email' )?.value || '';
	const emailValidation =
		document.querySelector( '#billing_email_validation' )?.value || '';

	return email === emailValidation;
}

export { attachEventListeners };
